export default {
    'read': 'display the content of a story following by its index',
    'play': 'plays the audio of a story following by its index',
    'pause': 'pauses story audio is any is playing',
    'top-stories': 'shows the top 5 stories of the moment',
    'get-story': 'get the content of a story based on the provided slug',
    'tag': 'search for the top stories related to a tag',
    show: false,
    'reset': `reload the terminal main screen`,
    'hack': 'try me!',
    'tldr': 'shows tldr of the indexed story',
    'open-img': 'open the feature image of a story following by its index',
    'writer': 'open the offical page of the writer of a story following by its index',
    'open': 'open the offical page of a story following by its index',
    'show-stories': 'shows previous stories list',
    'set-machine-name': 'change the machine name then reloads it',
    'machine-specs': 'describes machine specs',
    'ad': `open sponsor's page`,
    'contact': 'open HN contact page',
    'search': 'open HackerNoon search about given input',
    'privacy': 'open HN privacy page',
    'terms': 'open HN terms & conditions page',
}
